import { msgTypes } from 'constants/msgTypes';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { RequestModel } from 'model/utilModels/RequestModel';
import React, { useEffect, useState } from 'react'
import { LocalStorageService } from 'services/auth/LocalStorageService';
import { MemberBankDetailsService } from 'services/menu/memberBankDetailsService/MemberBankDetailsService';
import "./DisplayMemberBank.scss";
import { MemberBankDetailsModel } from 'model/screensModels/MemberBankDetailsModel';
import { conformationAlert } from 'services/shared/alert';
import CreateMemberBank from './CreateMemberBank';
import DialogBox from 'screens/sharedScreens/dialogbox/DialogBox';


const DisplayMemberBank = () => {
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [memberBankDetailsList, setMemberBankDetailsList] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })


  useEffect(() => {
    getBankDetailsList();
  }, [])

  useEffect(() => {
    getBankDetailsList();
  }, [onClose])

  //Prepare request body to get blog list
  const prepareRequest = async () => {
    const requestBody = new RequestModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = 50;//pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    const userDetails = JSON.parse(await LocalStorageService.getUserDetails());
    requestBody.companyId = userDetails.companyId;
    return requestBody;
  }

  //Get Member Bank Details list
  const getBankDetailsList = async () => {
    const requestBody = await prepareRequest();
    const res = await MemberBankDetailsService.getBankDetails(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        if (res.data?.tbody?.length > 0) {
          setMemberBankDetailsList(res?.data?.tbody);
        } else {
          setMemberBankDetailsList([]);
        }
      } else {
        setMemberBankDetailsList([]);
      }
    }
  }


  const removeBankDetails = async (bankId: string) => {
    const requestData: MemberBankDetailsModel = new MemberBankDetailsModel();
    requestData.bankId = bankId;

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");

    // const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR);
    if (deleteFlag) {
      const res = await MemberBankDetailsService.deleteBankDetails(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getBankDetailsList();
      }
    }
  }

  return (
    <>
     <div className='container'>
     <div className='create-bank-account'>
        <DialogBox
          title="Add Bank Details"
          buttonTitle="Add Bank Details"
          element={<CreateMemberBank setFlag={true} updateRecord={new MemberBankDetailsModel()} loadRecentBankDetails={new MemberBankDetailsModel()} />}
          setOnClose={setOnClose} />
        <div className="container p-0">
          <div className="row">
            {memberBankDetailsList.length > 0 ?
              <>
                {memberBankDetailsList.map((bankDetails: MemberBankDetailsModel) => {
                  return (

                    <div className='col-lg-6 card--'>
                     <div className='card-bank'>
                     <div className=' card-level bofa border-0'>
                        <div className="title bank-icon-home">
                          <i className="fa fa-university"></i>
                        </div>
                        <div className='bank-list'>
                          <div className="row bank--">
                            <div className="info col-md-6">
                              <p className="title-one">Account Holder Name: <span className='details-des'>{bankDetails.accountHolderName}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Account Number: <span className='details-des'>{bankDetails.accountNumber}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Bank Name: <span className='details-des'>{bankDetails.bankName}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Country: <span className='details-des'>{bankDetails.countryName}</span></p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="info col-md-6">
                              <p className="title-one">Currency: <span className='details-des'>{bankDetails.currency}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Branch Name: <span className='details-des'>{bankDetails.branchName}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Swift Code: <span className='details-des'>{bankDetails.swiftCode}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">IBAN NO: <span className='details-des'>{bankDetails.iban}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Routing No: <span className='details-des'>{bankDetails.routingNo}</span></p>
                            </div>
                            <div className="info col-md-6">
                              <p className="title-one">Type: <span className='details-des'>{bankDetails.type}</span></p>
                            </div>


                          </div>
                          <div className="footer col-sm-12">
                            <div className="action bank-switch-detail reveal">
                         
                              <a onClick={(e) => { removeBankDetails(bankDetails.bankId) }} href="javascript:void(0)">Remove</a>
                            </div>
                          </div>
                        </div>
                      </div>
                     </div>
                    </div>
                  )
                })}
              </>
              : (
                <div className="no-data-found pb-4 d-table h-100">
                  <div className="no-announcement-record text-center p-3 border">
                    <img src="/images/no-data-found.png" alt="" />
                    <p className="text-center">There is no bank details.</p>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div >

     </div>
    </>
  )
}

export default DisplayMemberBank;
